import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "liveness_wrapper" }
const _hoisted_2 = { class: "liveness_block_wrapper" }
const _hoisted_3 = { class: "liveness_title" }
const _hoisted_4 = {
  key: 0,
  class: "wrong_text"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "continue_block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aba_button = _resolveComponent("aba-button")!
  const _component_loading = _resolveComponent("loading")!
  const _directive_localization = _resolveDirective("localization")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createTextVNode(" Для завершения регистрации необходимо пройти проверку liveness ")
      ])), [
        [_directive_localization, 'Identification.Liveness.Title']
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.isPassed)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(" Проверка пройдена ")
          ])), [
            [_directive_localization, 'Identification.Liveness.PassedMessage']
          ])
        : _createCommentVNode("", true),
      (!_ctx.isPassed &&!_ctx.IsStarted)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "beneficiary_add_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.livenessStart && _ctx.livenessStart(...args)))
          }, null, 512)), [
            [_directive_localization, 'Identification.Liveness.ButtonStart']
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.isLoading &&_ctx.isPassed)
        ? (_openBlock(), _createBlock(_component_aba_button, {
            key: 0,
            class: "active m-2",
            isDisabled: !_ctx.isPassed,
            btnSize: "btnLarge",
            onClick: _ctx.saveAndContinue
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode("  "),
              _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Continue")), 1)
            ]),
            _: 1
          }, 8, ["isDisabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_loading, {
            key: 1,
            class: "continue_loading"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}